module.exports = __webpack_public_path__ + "static/27-2328c4003fbc5080e995718f9c8f5df0.gif";